import { FC } from 'react'
import clsx from 'clsx'

import { STATIC_URL } from '../../../constants/data'
import numericToWord from '../../../utils/numericToWord'

import styles from './webinar-viewers.module.scss'

interface IWebinarViewers {
  viewers?: number | string
  short?: boolean
}

const imgPath = `${STATIC_URL}/active-webinar-card/icon_people_red.svg`

const humanVariants = ['человек', 'человека']

const WebinarViewers: FC<IWebinarViewers> = ({ viewers = '', short }: IWebinarViewers) => {
  const humans = short ? 'чел.' : numericToWord(Number(viewers), humanVariants)
  return (
    <div className={styles.peopleBig}>
      <img
        src={imgPath}
        className={styles.peopleIcon}
        alt="количество зрителей вебинара"
        decoding="async"
        loading="lazy"
      />
      <p
        className={clsx(styles.peopleBigText, {
          [styles.peopleShort]: short,
        })}
      >
        {viewers} {humans}
      </p>
    </div>
  )
}

export default WebinarViewers
